import { render, staticRenderFns } from "./InboxToolbar.vue?vue&type=template&id=37ecd66a&"
import script from "./InboxToolbar.vue?vue&type=script&lang=js&"
export * from "./InboxToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports